import React from 'react';
import { Notification } from 'react-admin';

export const MyNotification = props => <Notification {...props} autoHideDuration={5000} />;